import React from 'react'
import Modal from '../../../../../../components/Modal/Modal'

const DeleteUploadModal = ({ isOpen, onClose, onDelete, uploadName }) => {
  return (
    <Modal
    isOpen={isOpen}
    onClose={onClose}
    >
      <Modal.Header>
        <h2>Delete Upload</h2>
      </Modal.Header>
      <Modal.Body>
        <div className="flex flex-col">
          <h5 className='text-lg'>Are you sure you want to delete?</h5>
          <p className='text-rb-green font-bold'>{uploadName}</p>
          <p className='mt-4'>All comments saved to this upload will be lost.</p>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="w-full flex justify-between items-center"> 
          <button className='rb-btn-cancel px-4 py-2 rounded-lg' onClick={onClose}>Cancel</button>
          <button className='rounded-lg bg-red-500 text-white px-4 py-2' onClick={onDelete}>Delete</button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}

export default DeleteUploadModal


// <div className="flex justify-between mt-5">
// <button
//   className={`${edit ? '' : 'hidden '}flex items-center`}
//   onClick={() => {
//     removeContact()
//     setIsOpen(false)
//   }}
// >
//   <Trash />
//   <span className="ml-1">Delete contact</span>
// </button>
// <button
//   type="button"
//   className={`${edit ? '' : 'ml-auto '}submit text-white bg-rb-green border-2 rounded-lg px-4 py-2 text-center active:shadow-outer active:shadow-rb-green border-rb-green`}
//   onClick={() => handleAddUpdateSubmit()}
// >
//   {edit ? 'Update Contact' : 'Add contact'}
// </button>
// </div>